export default "__VITE_ASSET__LMZ$q7SJ__"